const noEditableStyleConcrete = {
  backgroundColor: '#e6e6e6',
  cursor: 'not-allowed',
  padding: '10px 10px',
  textAlign: 'right',
};

const noEditableStyle = {
  backgroundColor: '#e6e6e6',
  cursor: 'not-allowed',
};

const inputStyleConcrete = {
  width: '70%',
  textAlign: 'right',
  color: 'black',
};

const inputStyle = {
  width: '100%',
  textAlign: 'center',
  color: 'black',
};

const editableStyle = {
  width: '50%',
  borderRight: '2px solid #f1f1f1',
  borderTop: '2px solid #f1f1f1',
  padding: '10px 10px',
};

export {
  noEditableStyle,
  inputStyle,
  editableStyle,
  inputStyleConcrete,
  noEditableStyleConcrete,
};
